import {FormField} from './types';

export const isActiveFormField = (formField?: FormField) => !!formField?.is_active;

export const isRequiredFormField = (formField?: FormField) => !!formField?.is_required;
